export const URI_ORGANIZATIONLOCATION = "/api/organizationlocation";
export const URI_ORGANIZATIONLOCATION_ADD = "/api/organizationlocation";
export const URI_ORGANIZATIONLOCATION_DELETE = "/api/organizationlocation/:id";
export const URI_ORGANIZATIONLOCATION_EDIT = "/api/organizationlocation/:id";
export const URI_ORGANIZATIONLOCATION_FORM = "/api/organizationlocation/:id/form";
